import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ConfirmationPopup } from '../../../core/components';
import { EndCallReasons } from '../../../../common/services/doxy-analytics/tracks/video-session-end';
import * as call from '../../';
export const EndCallConfirmationPopup = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector(call.selectors.isEndCallAttempt);
    const onCancel = () => dispatch(call.actions.resetEndCallAttempt());
    const onConfirm = () => {
        dispatch(call.actions.endCallByUser(EndCallReasons.CANCEL));
        dispatch(call.actions.resetEndCallAttempt());
    };
    return (<ConfirmationPopup isOpen={isOpen} onCancel={onCancel} onConfirm={onConfirm} className="end-call-confirmation-popup" localizationIds={{
            title: 'call.actions.endCallConfirmation.title',
            confirm: 'call.actions.endCallConfirmation.confirm',
        }}/>);
};
